// extracted by mini-css-extract-plugin
export var box = "_s-0";
export var check = "_s-1";
export var checkboxButton = "_s-6";
export var checkboxGroup = "_s-5";
export var disabled = "_s-7";
export var ghost = "_s-9";
export var input = "_s-2";
export var label = "_s-4";
export var normal = "_s-8";
export var uncheck = "_s-3";